import classNames from 'classnames';
import React from 'react';
import './StepsPageBackground.scss';

export interface StepsPageBackgroundProps {
  size?: 'small' | 'large';
}

export const StepsPageBackground: React.VFC<StepsPageBackgroundProps> = ({
  size,
}) => (
  <div>
    <div
      className={classNames(
        'steps-page-background-design',
        'college-branded-header',
        { [`steps-page-background-${size}`]: size }
      )}
    />
    <div className={'steps-page-background'} />
  </div>
);

export default StepsPageBackground;
